import React from "react"

export const SessionExpired = () =>{
    return(
        <>
            <p>Your session has expired.  You have been logged out. Please log in again</p>
        </>
    )
}